import React from 'react';
import { CopyButton } from '../../../../components';
import { typography, palette } from '../../../../utils/designTokens';

/**
 * SectionHeader - Reusable section header with optional copy button
 *
 * @param {string} title - Section title
 * @param {React.ReactNode} icon - Optional icon to display before title
 * @param {string} copyText - Text to copy (if provided, shows copy button)
 * @param {string} copyLabel - Accessible label for copy button
 */
const SectionHeader = ({ title, icon, copyText, copyLabel }) => {
  return (
    <div className="flex items-center justify-between mb-2">
      <div className={`${typography.size.metadata} font-semibold text-text-muted uppercase flex items-center gap-2`}>
        {icon}
        {title}
      </div>
      {copyText && (
        <CopyButton
          text={copyText}
          size="xs"
          label={copyLabel || `Copy ${title}`}
        />
      )}
    </div>
  );
};

export default SectionHeader;
